import { useContext } from "react";
import { PrivacyPreferencesContext } from "../providers/PrivacyPreferencesProvider";

export function usePrivacyPreferences() {
  const context = useContext(PrivacyPreferencesContext);
  if (!context) {
    throw new Error(
      "usePrivacyPreferences must be used within PrivacyPreferencesProvider",
    );
  }

  return context;
}
